function debounce(func) {
  var wait =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var immediate =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var timeout;
  return function () {
    var context = this,
      args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// Color Images on Scroll on Mobile

var sliderImages = document.querySelectorAll(".grayscale");
if (sliderImages) {
  function checkSlide() {
    sliderImages.forEach(function (sliderImage) {
      var slideInAt =
        window.scrollY + window.innerHeight - sliderImage.height / 3; // bottom of the image

      var imageBottom = sliderImage.offsetTop + sliderImage.height;
      var isHalfShown = slideInAt > sliderImage.offsetTop;
      var isNotScrolledPast = window.scrollY < imageBottom;

      if (isHalfShown && isNotScrolledPast) {
        sliderImage.classList.add("colorin");
      } else {
        sliderImage.classList.remove("colorin");
      }
    });
  }

  window.addEventListener("scroll", debounce(checkSlide));
}

// Back to Top Arrow

function topArrow() {
  var body = document.body,
    html = document.documentElement;

  var height = Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight
  );

  var slideInAt = window.scrollY + window.innerHeight; // bottom of the image

  var scrollUp = document.getElementById("upwescroll");
  if (slideInAt > height - 1000) {
    scrollUp.classList.add("scrollactive");
  } else {
    scrollUp.classList.remove("scrollactive");
  }
}

window.addEventListener("scroll", debounce(topArrow));

// var scrollUp = document.getElementById("scroll-up");
// window.addEventListener("click", scrollUp.classList.remove("scrollactive"));

// Fixed Nav

// var nav = document.querySelector("#site-navigation");
// var mainmenuwrapper = document.querySelector("#mainmenuwrapper");
// if (nav) {
//   var topOfNav = nav.offsetTop;
//   function fixNav() {
//     if (window.scrollY >= topOfNav) {
//       document.body.classList.add("fixed-nav");
//     } else {
//       document.body.classList.remove("fixed-nav");
//     }
//   }

//   var mobiletop = document.querySelector(".content-area");
//   if (mobiletop) {
//     var topOfNavMobile = mobiletop.offsetTop;
//   }

//   function fixNav() {
//     if (window.scrollY >= topOfNavMobile) {
//       document.body.classList.add("fixed-nav");
//     } else {
//       document.body.classList.remove("fixed-nav");
//     }
//   }
//   window.addEventListener("scroll", fixNav);
// }
